import { GlobalToken } from 'antd/es/theme/interface'
import { CellValidator } from '../../../../helpers/cell-validators'
import { getMaterialValidationResult } from '../../../../helpers/entities/material/get-material-validation-result'
import Shipment from '../../../../types/api/shipment'

export const validateMaterial: CellValidator = (record, token: GlobalToken) => {
    if (!('materialRequirements' in record)) {
        return null
    }

    return getMaterialValidationResult(record as Shipment, token)
}
